import React from 'react'
import MercadoPagoView from './mercadopago'

const MercadoPagoKyc = () => <MercadoPagoView kyc />

export default MercadoPagoKyc
